import CertificateItemComponent from './certificate-item.component'

const CertificateItemModule = angular.module('cdbl.certificate-item', [

])
  .component('cdblCertificateItem', CertificateItemComponent)
  .name

export default CertificateItemModule
